// extracted by mini-css-extract-plugin
export default {"bgFooter":"footer_bgFooter__-iRd-"};